import GroupFieldNamesData from './GroupFieldNamesData';

const useGroupFieldNamesData = () => {
  return {
    GROUP_CONSTANTS: { ...GroupFieldNamesData }
  };
};

export default useGroupFieldNamesData;